import * as React from "react";
import styled from "styled-components";
import { E2EIdentifier } from "../../../core/e2e/E2EIdentifier";
import * as h from "../../../ui/_themes/helpers";
import { mobile } from "../../../ui/_themes/constants";

const ELEMENT_ID = "betButton";

export interface IBetButtonProps {
  className?: string;
  apiName?: string;
  state: State;
  onClick(e: any): void;
}

export enum State {
  DEFAULT,
  ACTIVE,
  DISABLED
}

const View = ({ className, apiName, state, onClick }: IBetButtonProps) => {
  return (
    <div
      className={className}
      data-api-name={apiName}
      data-e2e-id={E2EIdentifier.KEYPAD_BET_BUTTON}
      data-state={state}
      onClick={onClick}
    >
      <svg viewBox="0 0 38 38" version="1.1">
        <g stroke="none" strokeWidth="1" fillRule="evenodd">
          <g transform="translate(-327.000000, -578.000000)">
            <g transform="translate(327.000000, 578.000000)">
              <g>
                <path
                  d="M1.5,19a17.5,17.5 0 1,0 35,0a17.5,17.5 0 1,0 -35,0"
                  strokeWidth="3"
                />
                <g transform="translate(11.453846, 10.000000)">
                  <path d="M15.2307696,14.2307696 L15.2307696,16.515385 C15.2307696,17.7771433 11.8212457,18.8000004 7.61538478,18.8000004 C3.50966345,18.8000004 0.162809719,17.8252709 0.00576323865,16.6050937 L0,16.515385 L0,14.2307696 C0,15.4925278 3.4095239,16.515385 7.61538478,16.515385 C11.7211061,16.515385 15.0679598,15.5406555 15.2250063,14.3204783 L15.2307696,14.2307696 Z" />
                  <path d="M15.2307696,9.66153869 L15.2307696,11.9461541 C15.2307696,13.2079124 11.8212457,14.2307696 7.61538478,14.2307696 C3.50966345,14.2307696 0.162809719,13.25604 0.00576323865,12.0358628 L0,11.9461541 L0,9.66153869 C0,10.923297 3.4095239,11.9461541 7.61538478,11.9461541 C11.7211061,11.9461541 15.0679598,10.9714246 15.2250063,9.75124741 L15.2307696,9.66153869 Z" />
                  <path d="M15.2307696,5.09230782 L15.2307696,7.37692326 C15.2307696,8.63868152 11.8212457,9.66153869 7.61538478,9.66153869 C3.50966345,9.66153869 0.162809719,8.68680916 0.00576323865,7.46663197 L0,7.37692326 L0,5.09230782 C0,6.35406609 3.4095239,7.37692326 7.61538478,7.37692326 C11.7211061,7.37692326 15.0679598,6.40219372 15.2250063,5.18201654 L15.2307696,5.09230782 Z" />
                  <path d="M0,2.80769239a7.61538478,2.28461543 0 1,0 15.23076956,0a7.61538478,2.28461543 0 1,0 -15.23076956,0" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};

export const BetButton = styled(View)`
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;

  pointer-events: all;

  cursor: pointer;
  border-radius: 50%;

  &[data-state="${State.DEFAULT}"] {
    > svg > g {
      fill: none;
      > g > g > g > {
        path {
          stroke: ${h.getColor(ELEMENT_ID)};
        }
        g {
          fill: ${h.getColor(ELEMENT_ID)};
        }
      }
    }

    &:hover {
      > svg > g > g > g > g > {
        path {
          stroke: ${h.getHoverColor(ELEMENT_ID)};
        }
        g {
          fill: ${h.getHoverColor(ELEMENT_ID)};
        }
      }
    }

    &:active {
      > svg > g > g > g > g > {
        path {
          stroke: ${h.getPressedColor(ELEMENT_ID)};
        }
        g {
          fill: ${h.getPressedColor(ELEMENT_ID)};
        }
      }
    }
  }

  &[data-state="${State.ACTIVE}"] {
    > svg > g {
      fill: ${h.getActiveColor(ELEMENT_ID)};
      > g > g > g > {
        path {
          stroke: ${h.getActiveColor(ELEMENT_ID)};
        }
        g {
          fill: #000;
        }
      }
    }

    &:hover {
      > svg > g {
        fill: ${h.getHoverColor(ELEMENT_ID)};

        > g > g > g > path {
          stroke: ${h.getHoverColor(ELEMENT_ID)};
        }
      }
    }

    &:active {
      > svg > g {
        fill: ${h.getPressedColor(ELEMENT_ID)};

        > g > g > g > path {
          stroke: ${h.getPressedColor(ELEMENT_ID)};
        }
      }
    }
  }

  &[data-state="${State.DISABLED}"] {
    touch-action: none;
    pointer-events: none;
    user-select: none;

    > svg > g {
      fill: none;
      > g > g > g > {
        path {
          stroke: ${h.getDisabledColor(ELEMENT_ID)};
        }
        g {
          fill: ${h.getDisabledColor(ELEMENT_ID)};
        }
      }
    }
  }

  > svg {
    width: 2.1em;
    height: 2.1em;
  }
`;

export const BetButtonWrapperForMobile = styled.div`
  width: 2.9em;
  height: 2.9em;
  align-self: center;

  > ${BetButton} {
    &:after {
      display: block;
      content: "";
      width: 2.9em;
      height: 2.9em;
      position: absolute;
      top: -0.4em;
      left: -0.4em;
      border-radius: 50%;
    }
  }

  @media (orientation: landscape) {
    width: 2.2em;
    height: 2.2em;

    > ${BetButton} {
      &:after {
        width: 2.2em;
        height: 2.2em;
      }
      > svg {
        width: ${mobile.landscape.sidePanel.icon.width};
        height: ${mobile.landscape.sidePanel.icon.height};
      }
    }
  }

  display: flex;
  justify-content: center;
  align-items: center;
  background: ${h.getBackgroundColor("keypadIcons", "keypad.icons")};
  border-radius: 50%;
`;
